/** @jsx jsx */
import { jsx } from "@emotion/react";
import { noop } from "lodash";
import {
  TableCellValue,
  TableColumns,
  TableRow,
} from "../../../../../../requests/table/types";
import {
  ColumnFormatDict,
  ValueFormat,
} from "../../../../../../requests/templates/types";
import { FlowioTableCellInput } from "../../../../../atoms/inputs/FlowioInput";
import { StyledDivTd } from "./styles";
import { LEFT } from "../../../../TemplateBuilder/TemplateItemEditor/FormatEditor/constants";

export type TableDataCellProps = {
  columns: TableColumns;
  columnsFormat: ColumnFormatDict;
  row: TableRow;
  cKey: string;
  editMode?: boolean;
  onInputChange?: (v: TableCellValue) => void;
  onBlur?(): void;
  textColor: string;
  format: ValueFormat;
  refetchRowCallback?: () => void;
};

const TableDataCell = ({
  columns,
  cKey,
  row,
  editMode = false,
  onInputChange,
  onBlur,
  textColor,
  columnsFormat,
  format,
  refetchRowCallback,
}: TableDataCellProps) => {
  const column = columns[cKey];

  const { templateId, cells } = row;
  const { value, unformattedValue } = cells[cKey];

  if (column.inputType === "hidden") return null;

  const textAlign = format?.general?.textAlign ?? LEFT;

  return (
    <StyledDivTd
      textColor={textColor}
      textAlign={textAlign}
      className="tableCol"
      data-cy={`${cKey}-input-column`}
    >
      <FlowioTableCellInput
        value={value}
        unformattedValue={unformattedValue}
        format={format}
        column={column}
        columnsFormat={columnsFormat}
        templateId={Number(templateId)}
        editable={editMode && column.editable}
        onChange={onInputChange}
        onBlur={onBlur}
        // textAreaConfig={{ maxLength: 2 }}
        refetchRowCallback={refetchRowCallback}
        row={row}
        columns={columns}
      />
    </StyledDivTd>
  );
};

export default TableDataCell;
